import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "px-6 py-16 md:px-20 md:py-20 rounded-3xl shadow-sm flex flex-col lg:flex-row gap-10 lg:gap-20 justify-between gradient-background" }
const _hoisted_2 = { class: "flex flex-col justify-center" }
const _hoisted_3 = { class: "flex flex-col justify-center" }

import { computed } from "vue";
import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import { PageBlock } from "@/views/blocks/PageBlock.interface";
import { TwoColumnsWithPhotoProps } from "./cta.interfaces";
import EditableElement from "@/views/page/EditableElement.vue";

import Section from "@/views/blocks/shared/section/layout/section/Section.vue";
import FullSpacing from "@/views/blocks/shared/section/layout/spacing/FullSpacing.vue";
import Heading from "@/views/blocks/shared/section/typography/heading/Heading.vue";
import Paragraph from "@/views/blocks/shared/section/typography/paragraph/Paragraph.vue";
import SecondaryButton from "@/views/blocks/shared/section/buttons/secondary-button/SecondaryButton.vue";
import Image from "@/views/blocks/shared/section/image/Image.vue";
import List from "./components/list/List.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TwoColumnsWithPhoto',
  props: {
    block: {},
    pageColors: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "5c1f709f": (styleValues.value.brand)
}))

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Section, {
    id: _ctx.block.webId,
    "background-color": styleValues.value.background
  }, {
    default: _withCtx(() => [
      _createVNode(FullSpacing, { class: "max-w-7xl mx-auto" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (!dataValues.value.image.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 0,
                    "block-id": _ctx.block.id,
                    "field-name": "image"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Image, {
                        src: dataValues.value.image.data.src,
                        alt: dataValues.value.image.data.alt,
                        class: "h-full max-h-96 lg:max-w-sm object-cover rounded-2xl",
                        width: "800",
                        height: "475"
                      }, null, 8, ["src", "alt"])
                    ]),
                    _: 1
                  }, 8, ["block-id"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              (!dataValues.value.title.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 0,
                    "block-id": _ctx.block.id,
                    "field-name": "title"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Heading, {
                        tag: dataValues.value.title.data.tag,
                        text: dataValues.value.title.data.text,
                        "text-color": styleValues.value.text,
                        class: "text-4xl sm:text-5xl"
                      }, null, 8, ["tag", "text", "text-color"])
                    ]),
                    _: 1
                  }, 8, ["block-id"]))
                : _createCommentVNode("", true),
              (!dataValues.value.description.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 1,
                    "block-id": _ctx.block.id,
                    "field-name": "description"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Paragraph, {
                        text: dataValues.value.description.data.text,
                        "text-color": styleValues.value.text,
                        class: "mt-6 text-lg/8 opacity-70"
                      }, null, 8, ["text", "text-color"])
                    ]),
                    _: 1
                  }, 8, ["block-id"]))
                : _createCommentVNode("", true),
              _createVNode(List, {
                items: dataValues.value.listItems.data.items,
                "text-color": styleValues.value.text,
                "checkmark-color": styleValues.value.brand,
                "block-id": _ctx.block.id,
                class: "mt-10"
              }, null, 8, ["items", "text-color", "checkmark-color", "block-id"]),
              (!dataValues.value.link.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 2,
                    "block-id": _ctx.block.id,
                    "field-name": "link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SecondaryButton, {
                        label: dataValues.value.link.data.label,
                        href: dataValues.value.link.data.href,
                        "text-color": styleValues.value.brand,
                        class: "mt-10 w-fit"
                      }, null, 8, ["label", "href", "text-color"])
                    ]),
                    _: 1
                  }, 8, ["block-id"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "background-color"]))
}
}

})